import { render, staticRenderFns } from "./mitigationItem.vue?vue&type=template&id=95c7fee0"
import script from "./mitigationItem.vue?vue&type=script&lang=js"
export * from "./mitigationItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports